import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import * as Api from 'api';


/***************************** Subroutines ************************************/
function * favoriteMap({payload}) {
  try {
    yield call(Api.favoriteMap, payload.id)
    yield put({
      type: ActionTypes.FAVORITE_MAP_SUCCESS,
      payload: {
        favorites: yield call(Api.fetchFavoriteMaps)
      }
    })
  }
  catch(ex) {
    yield put(Actions.notify({message : ex.message}));
  }
}

function * initMapMarkerTypes() {
  try {
    let users_markers = yield call(Api.fetchUsersMarkers)
    yield put(Actions.setMarkerTypes(users_markers))
    yield put(Actions.toggleMarkerTypesInitialized(true))
  }
  catch(e) {
    yield put(Actions.notify({message : e.message || e}))
  }
}


/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function * mapsWatcher() {
  yield * [
    takeEvery(ActionTypes.FAVORITE_MAP, favoriteMap),
    takeEvery(ActionTypes.INIT_MAP_MARKER_TYPES, initMapMarkerTypes)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/maps.js